import React from "react";

import { proxy } from "@/util/proxy.mjs";

export const csgoBenchmarkRefs = { VideoAd: null };

export const OVERLAY_IDS = {
  csgoBenchmark: "csgoBenchmark",
  csgoBenchmarkAd: "csgoBenchmarkAd",
};

const cs2Refs = proxy({
  MatchReplay: React.lazy(() => import("@/game-csgo/MatchReplay.jsx")),
  replayLink: (_a, _b) => null,
  activityModal: {
    current: null as HTMLDialogElement | null,
  },
});

export default cs2Refs;
